import Flex from "../Flex";
import { Icon, Text, ToggleTip, Tooltip } from "nectar-ui";
import React from "react";

import { ActionWrapper, CardWrapper, TitleWrapper } from "./style";

interface DashboardChartWrapperProps {
  title: string;
  toggleTip: {
    title: string;
    text: React.ReactNode;
    alwaysOnLeft?: boolean;
    onClickCallback?: () => void;
    callToAction: {
      text?: string;
      callback?: () => void;
    };
  };
  description: string;
  children: React.ReactNode;
  showAction?: boolean;
}

const DashboardChartWrapper = ({
  title,
  description,
  toggleTip,
  children,
  showAction,
}: DashboardChartWrapperProps) => (
  <CardWrapper border>
    <Flex direction="column">
      <Flex justify="space-between">
        <Text size="lg" semiBold>
          <TitleWrapper>
            {title}
            <Tooltip title="Central de ajuda" placement="top">
              <ToggleTip
                title={toggleTip.title}
                message={toggleTip.text}
                icon="fa-question-circle-o"
                position={toggleTip.alwaysOnLeft ? "left" : "right"}
                toggleCallback={toggleTip.onClickCallback}
                callToActionText={toggleTip.callToAction.text}
                callToActionCallback={toggleTip.callToAction.callback}
                hideTooltip
              />
            </Tooltip>
          </TitleWrapper>
        </Text>
        {showAction && (
          <ActionWrapper>
            <Icon icon="fa-file-excel-o" />
            <Icon icon="fa-print" noMargin />
          </ActionWrapper>
        )}
      </Flex>
      <Text color="gray500">{description}</Text>
    </Flex>
    {children}
  </CardWrapper>
);

export default DashboardChartWrapper;
